import styled from "styled-components";
import { useParams } from "react-router-dom";

import * as yup from "yup";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import { InputPassword } from "../../components/form";
// import Button from "../components/ui/Button";
import { useLazyQuery, useMutation } from "@apollo/client";
import { CHANGE_PASSWORD, JWT_PASSWORD_CHECK } from "../../services/auth";
import { useEffect } from "react";
import { useState } from "react";
import { Button, TextLink } from "../../components/ui";
import { LogoClaims } from "../../assets/icons/Icons";
const schema = yup.object({
    password: yup
        .string("Ingresa una contraseña valida")
        .min(6, "Ingresa una contraseña valida"),
    confirm: yup
        .string()
        .oneOf([yup.ref("password"), null], "Las contraseñas no coinciden")
        .required()
});

const Container = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  margin-top: -80px;
  & > div > svg {
    margin-bottom: 50px;
  }
`;

const LoginWrapper = styled.div`
  border-radius: 20px;
  padding: 46px;
  display: flex;
  flex-direction: column;
  gap: 28px;
  width: 100%;
  max-width: 600px;
  box-shadow: 19px 70px 29px rgba(4, 3, 63, 0.01),
    11px 40px 25px rgba(4, 3, 63, 0.03), 5px 18px 18px rgba(4, 3, 63, 0.04),
    1px 4px 10px rgba(4, 3, 63, 0.05), 0px 0px 0px rgba(4, 3, 63, 0.05);
`;

const StyledTitle = styled.h2`
  font-weight: 700;
  font-size: 28px;
  color: #4f5e74;
  text-align: center;
  margin-bottom: 16px;
`;
const StyledMessage = styled.p`
    font-weight: 400;
    font-size: 16px;
    color: #218631;
    text-align: center;
    margin-top: 24px;
    ${({ error }) => error && `
    color: #F44336;
  `}
`;
const StyledSubtitle = styled.p`
  font-weight: 400;
  font-size: 14px;
  color: #3E4451;
  text-align: center;
  margin-bottom: 44px;
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;


export default function ForgottenPassword() {
    const {
        handleSubmit,
        register,
        reset,
        formState: { errors },
    } = useForm({ resolver: yupResolver(schema) });
    const { token } = useParams();
    const [changePassword, resultChangePassword] = useMutation(CHANGE_PASSWORD);
    const [recoverStatus, setRecoverStatus ] = useState("");
    const formSubmit = (data) => {
        reset({
            password: "",
            confirm: "",
        });
        const { password } = data;
        changePassword({ variables: { password: password, token: token } });
    };

    const [validateToken, validationResult] = useLazyQuery(JWT_PASSWORD_CHECK);
    const [isValid, setIsValid] = useState(true);


    useEffect(() => {
        validateToken({ variables: { token: token } });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [token]);


    useEffect(() => {
        if (validationResult.data) {
            if (validationResult.data?.validateToken?.statusCode === 200) {
                setIsValid(true);
            } else {
                setIsValid(false);
            }
        }
    }, [validationResult]);

    useEffect(() => {
        if (resultChangePassword.data) {
            if (resultChangePassword.data?.recoverPassword?.statusCode === 200) {
                setRecoverStatus("Success");
            } else {
                setRecoverStatus("Error");
            }
        }
    }, [resultChangePassword]);
    return (
        <Container>
            <LogoClaims w="240" h="60" />
            <StyledTitle>¿Olvidaste tu contraseña?</StyledTitle>
            <StyledSubtitle>Ingresa tu correo electrónico para restablecer tu contraseña</StyledSubtitle>
            <LoginWrapper>
                {isValid ? (
                    <StyledForm onSubmit={handleSubmit(formSubmit)}>
                        <InputPassword
                            label="Ingresa tu nueva contraseña"
                            type="password"
                            placeholder="Contraseña"
                            register={{ ...register("password") }}
                            errorMessage={errors.password?.message}
                        />
                        <InputPassword
                            label="Confirmar contraseña"
                            type="password"
                            placeholder="Contraseña"
                            register={{ ...register("confirm") }}
                            errorMessage={errors.confirm?.message}
                        />
                        <Button
                            text={"Restablecer contraseña"}
                            type="submit"
                            style={{ display: "block", width: "100%" }}
                        />
                        {
                        recoverStatus === "Error" ? 
                            <StyledMessage error={true}>
                                Estamos presentando fallas técnicas por favor intente mas tarde
                            </StyledMessage>  : 
                        recoverStatus === "Success" ? 
                            <>
                            <StyledMessage error={false}>Tu contraseña ha sido cambiada con éxito.</StyledMessage> 
                            <TextLink to="/" text="Regresa para iniciar sesión"/>
                            </>
                        : null
                        }
                    </StyledForm>
                    
                ) : 
                <StyledMessage error={true}>
                    Estamos presentando fallas técnicas por favor intente mas tarde
                </StyledMessage>  
                }
            </LoginWrapper>
        </Container>
    );
}
